/**
 * A tab that stays open during a deployment can keep references to removed,
 * content-hashed route chunks. Recover once instead of leaving navigation on
 * the previous screen after the URL has already changed.
 */
export const RECOVER_STALE_CLIENT = `(function(){
  var key = 'hay:stale-client-reload';
  var pattern = /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|failed to fetch module script|unable to preload css/i;
  function messageOf(value){
    if (value && typeof value === 'object' && 'message' in value) return String(value.message || '');
    return String(value || '');
  }
  function recover(value){
    if (!pattern.test(messageOf(value))) return;
    try {
      if (sessionStorage.getItem(key) === location.href) return;
      sessionStorage.setItem(key, location.href);
    } catch (_) {}
    location.reload();
  }
  window.addEventListener('vite:preloadError', function(event){ recover(event.payload || event.error); });
  window.addEventListener('unhandledrejection', function(event){ recover(event.reason); });
  window.addEventListener('error', function(event){ recover(event.error || event.message); }, true);
})();`;
